import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {MapsAPILoader} from '@agm/core';

declare const google;

@Component({
  selector: 'app-map',
  styleUrls: ['./map.component.scss'],
  templateUrl: './map.component.html',
})
export class MapComponent implements OnChanges {

  @Input() zoom = 15;
  @Input() limitZoom = 12;
  @Input() latitude: number;
  @Input() longitude: number;
  @Input() radius = 500;
  @Input() streetView: true | false = false;
  @Input() colorRadius = '#ed1c29';
  @Input() idMap = 'map';

  constructor(public apiLoader: MapsAPILoader) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.streetView && changes.streetView.currentValue === true) {
      this.openStreetView();
    }
  }

  openStreetView() {
    this.apiLoader.load()
      .then(() => {
        this.newStreetPanorama();
      });
  }

  newStreetPanorama() {
    const streetView = document.getElementById(`street-view-${this.idMap}`);

    if (streetView) {
      return new google.maps.StreetViewPanorama(
        streetView, {
          position: {lat: this.latitude, lng: this.longitude},
          pov: {
            heading: 0,
            pitch: 0,
            zoom: 1
          }
        });
    }
  }
}
